//import config from 'config';
import { authHeader } from '../helpers';

export const userService = {
    login,
    logout,
    authUser
};
// https://jasonwatmore.com/post/2018/07/06/vue-vuex-jwt-authentication-tutorial-example
function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    //return fetch(`${config.apiUrl}/users/authenticate`, requestOptions)
    return fetch('/api/users/authenticate', requestOptions)
        .then(handleResponse)
        .then(user => {

            // login successful if there's a user in the response
            if (user.token && user.token != "") {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }
            else {
                logout();
            }

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function authUser() {

    var requestHeader = authHeader();
    requestHeader["Content-Type"] = "application/json";

    const requestOptions = {
        method: 'POST',
        headers: requestHeader,
        body: localStorage.getItem('user')
    };

    return fetch('/api/users/authenticateUser', requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a user in the response
            if (user.token && user.token != "") {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }
            else {
                logout();
            }

            return user;
        });
}

function handleResponse(response) {

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}